var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleItems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5605 7.08984H11.4551V0.439453C11.4551 0.196758 11.2583 0 11.0156 0H3.98438C3.74168 0 3.54492 0.196758 3.54492 0.439453V7.08984H0.439453C0.196758 7.08984 0 7.2866 0 7.5293V14.5605C0 14.8032 0.196758 15 0.439453 15H14.5605C14.8032 15 15 14.8032 15 14.5605V7.5293C15 7.2866 14.8032 7.08984 14.5605 7.08984ZM10.6033 7.96875H11.4822V9.69727H10.6033V7.96875ZM3.51343 7.96875H4.39233V9.69727H3.51343V7.96875ZM7.06055 0.878906H7.93945V2.63672H7.06055V0.878906ZM4.42383 0.878906H6.18164V3.07617C6.18164 3.31887 6.3784 3.51562 6.62109 3.51562H8.37891C8.6216 3.51562 8.81836 3.31887 8.81836 3.07617V0.878906H10.5762V7.04408H4.42383V0.878906ZM0.878906 7.96875H2.63452V10.1367C2.63452 10.3794 2.83128 10.5762 3.07397 10.5762H4.83179C5.07448 10.5762 5.27124 10.3794 5.27124 10.1367V7.96875H7.06055V14.1211H0.878906V7.96875ZM14.1211 14.1211H7.93945V7.96875H9.72437V10.1367C9.72437 10.3794 9.92112 10.5762 10.1638 10.5762H11.9216C12.1643 10.5762 12.3611 10.3794 12.3611 10.1367V7.96875H14.1211V14.1211Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleItems);
export default __webpack_public_path__ + "static/media/multiple-items.e6a14faaaa463c9382793fce68dafadd.svg";
export { ForwardRef as ReactComponent };